module.exports = __webpack_public_path__ + "img/header-green-top-square.5a928d49.svg";